<!--
data form viewer dialog
not to be used any more

-->

<template>
  <div>
    <v-dialog v-model="dialog" scrollable>
      <template v-slot:activator="{ on }">
        <v-btn round small color="primary" v-on="on" dark>view</v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Add User</v-card-title>

        <v-card-text>
          <template v-for="(item, index) in questionsName">
            <v-card
              v-bind:key="item.value"
              class="mx-auto"
              color="#26c6da"
              dark
              style="    margin-bottom: 10px;"
            >
              <v-card-title style="padding-top: 10px;padding-bottom: 5px;padding-left: 0px;">
                <v-icon large left>mdi-twitter</v-icon>
                <span class="title font-weight-light">{{item.name}}</span>
              </v-card-title>
              <v-card-text
                class="font-weight-light"
                style="padding-top: 0px;padding-bottom: 5px;"
              >{{ getTheResultValue(item.name) }}</v-card-text>
            </v-card>
          </template>

          <v-spacer></v-spacer>
          <v-card class="mx-auto" color="#26c6da" dark>
            <v-card-title style="padding-top: 10px;padding-bottom: 5px;padding-left: 0px; ">
              <v-icon large left>mdi-twitter</v-icon>
              <span class="title font-weight-light">Location</span>
            </v-card-title>
            <GmapMap
              :center="{lat:10, lng:10}"
              :zoom="7"
              map-type-id="terrain"
              style=" height: 300px"
            ></GmapMap>
          </v-card>

          <!-- <GmapMap
            :center="{lat:10, lng:10}"
            :zoom="7"
            map-type-id="terrain"
            style="width: 500px; height: 300px"
          ></GmapMap>-->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="submitData">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as SurveyVue from "survey-vue";

import * as widgets from "surveyjs-widgets";
import "inputmask/dist/inputmask/phone-codes/phone.js";
//And initialize widgets you are want ti use
widgets.icheck(SurveyVue);
widgets.select2(SurveyVue);
widgets.inputmask(SurveyVue);
widgets.jquerybarrating(SurveyVue);
widgets.jqueryuidatepicker(SurveyVue);
widgets.nouislider(SurveyVue);
widgets.select2tagbox(SurveyVue);
widgets.signaturepad(SurveyVue);
widgets.sortablejs(SurveyVue);
widgets.ckeditor(SurveyVue);
widgets.autocomplete(SurveyVue);
widgets.bootstrapslider(SurveyVue);

var Survey = SurveyVue.Survey;
export default {
  components: {
    Survey
  },
  props: {
    resultData: Object,
    questionData: Array,
    questionSchema: Object
  },
  mounted() {
    console.log("mounted parsing question")
    this.parseQuestionFromSchema();
  },
  data() {
    return {
      form: {
        userName: "",
        mobileNumber: "",
        password: "",
        confirmPassword: "",
        city: "",
        branch: "",
        userType: ""
      },
      dialog: false,
      items: ["admin", "manager"],
      questionsName:[]
    };
  },
  methods: {
    submitData: function() {
      this.$emit("clicked", JSON.stringify(this.form));
      this.dialog = false;
    },
    objectToString: function() {
      console.log("resultData " + JSON.stringify(this.resultData));
      return JSON.stringify(this.resultData);
    },
    parseQuestionFromSchema: function() {
      console.log("parsing schema");

      // var Survey = SurveyVue.Survey;
      // var survey = new Survey.Model(this.questionSchema.formSchema);
      // console.log("surveyQuestion => " + survey.getQuizQuestions());
      var model = new SurveyVue.Model(
        JSON.stringify(this.questionSchema.formSchema)
      );
      console.log("allquestion=> " + JSON.stringify(model.getAllQuestions()));
      //survey.addNewPage("page1");
      this.questionsName=model.getAllQuestions();
      //console.log("surveyQuestion => " + survey.getQuestionByName("email") +" ==> "+ JSON.stringify(this.questionSchema.formSchema));
    },
    getTheResultValue: function(questionName) {
      try {
        return this.resultData.result["" + questionName];
      } catch (err) {
        return "";
      }
    }
  }
};
</script>